import React from 'react';
import {
  Text, 
  View, ScrollView, TouchableOpacity,
} from 'react-native';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import {Helmet} from 'react-helmet';

import { enUS } from './en-US.js';
import { zhHK } from './zh-HK.js';
import { host, api11 } from '../../config/api.js';
import { formStyles } from '../../config/styles.js';
import { clearEmptyStrings, hmacSha256, msgCodeDetail} from '../../lib/utils.js';
import { memberStorage } from '../../lib/MemberStorage.js';
import { languageStorage } from '../../lib/LanguageStorage.js';
import Member from '../../Member.js';
import TextInput from '../../components/TextField/TextField.js';
import Navbar from '../../components/Navbar/Navbar.js';
import Footer from '../../components/Footer/Footer.js';
import Alert  from '../../components/Alert/Alert.js';
import validate from 'validate.js';
import ModalOTP from '../../components/ModalOTP/ModalOTP.js';
import { Redirect } from 'react-router-dom';
import PasswordPolicyTooltip from '../../components/Tooltip/PasswordPolicyTooltip.js';

export default class SetPasswordScreen extends React.Component {
  constructor(props) {
    super(props);

    const { username } = this.props.location.state || {};
    this.state = {
      text: {},
      mobileNumber: username,
      messages: {},
    };

    try {
      const searchParams = new URLSearchParams(this.props.location.search);

      const lang = searchParams.get('lang');
      if (lang) {
        switch (lang) {
          case 'en':
            languageStorage.setLanguage('enUS');
            break;
          case 'zh':
            languageStorage.setLanguage('zhHK');
            break;
        }
      }
    }
    catch (e) {
      if (e.name != 'ReferenceError') {
        throw e;
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    const getText = (language) => {
      let text = enUS;
      if (language == 'zhHK') {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage(
      (language) => this.setState({
        language: language,
        text: getText(language)
      }));
  }

  showError(text) {
    this.setState({
      alert: Alert.alert(this.state.text.alert, text || "Some Error happen" , [
        {
          text: this.state.text.ok,
          onPress: () => {
            this.setState({ alert: null });
          },
        },
      ]),
    });
  }

  async _clickSetPasswordButton() {
    const state = clearEmptyStrings(this.state);

    let attributes = {
      mobileNumber: this.state.mobileNumber,
      password: this.state.password,
    };

    let constraints = {
      mobileNumber: {
        presence: { message: this.state.text.thisFieldCannotBeBlank },
        numericality: { message: this.state.text.invalidMobileNumber },
        length: { is: 8, message: this.state.text.invalidMobileNumber },
      },
      password: {
        passwordPolicy: true,
      },
    };

    const messages = validate(attributes, constraints, { fullMessages: false });

    if (messages) {
      this.setState({ messages });
      return;
    }

    this.setState({messages: {}});

    const responseJson = await this._setPassword();
    if (responseJson.msgCode == 0) {
      Member.load().then((member) => (Member._member = member));
      memberStorage.setMember(
        responseJson.msgDesc.member,
        responseJson.msgDesc.token,
        () => {
          this.setState({
            alert: Alert.alert(
              this.state.text.welcome,
              this.state.text.passwordSet,
              [
                {
                  text: this.state.text.ok,
                  onPress: () => {
                    this.props.history.push("/")
                    return;
                  },
                  //onPress: () => this.props.history.push("/privilegedClubList")
                },
              ]
            ),
          });
        }
      );
    } else if (responseJson.msgCode == 31) {
      this.setState({
        alert: Alert.alert(
          this.state.text.youHaveRegistered,
          this.state.text.alreadyRegistered,
          [
            {
              text: this.state.text.login,
              onPress: () => this.props.history.push("Login"),
            },
          ],
          { cancelable: false }
        ),
      });
    } else {
      this.showError(
        responseJson.msgCode
          ? msgCodeDetail(responseJson.msgCode)[
              this.state.language == "enUS" ? "desc_en" : "desc_zh"
            ]
          : this.state.text.setPasswordError
      );
      this.setState({ registering: false });
    }
  }

  async _setPassword() {
    const { username, otpCode } = this.props.location.state || {};
    if (this.state.registering) {
      return;
    }
    this.setState({ registering: true });
    const data = JSON.stringify({
      username: username,
      password: this.state.password,
      verify_code: otpCode,
      timeStamp: Date.now(),
    });
    try {
      const hmac = hmacSha256(data);
      const response = await fetch(host + "/member/password/init", {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });
      const responseJson = response.json();
      return responseJson;
    } catch (error) {
      console.error("SetPasswordScreen ~ _setPassword ~ error:", error);
    } finally {
      this.setState({ registering: false });
    }
  }

  render() {
    const { username } = this.props.location.state || {};

    if (!username) {
      return <Redirect to="/forgot-password" />;
    }

    return (
      <div className="App">
        <Helmet>
          <title>Setup Password | Bravo Generali </title>
        </Helmet>

        <Navbar
          title={this.state.text.setPassword}
          backButton
          history={this.props.history}
        />

        <Grid container spacing={20} style={{backgroundColor: '#f2f2f2'}}>
        <Hidden xsDown>
          <Grid item xs style={{marginBottom:13,marginLeft:'5%',marginRight:'5%'}}>
              {/* <View style={[styles.greeting,{fontWeight:'bold',}]}>
                <Text style={[styles.greetingText,{marginTop:'10%',fontSize: 35,}]}>{this.state.text.setPassword}</Text>
              </View> */}
          </Grid>
          </Hidden>

          <Grid item xs style={{marginTop:30,marginBottom:50,backgroundColor: 'white',}}>
          <ScrollView style={{...formStyles.form, ...styles.fieldsetldset}}>

            {this.state.alert}
            <View style={formStyles.fieldset}>
              <Text style={formStyles.h3}>{this.state.text.setPassword}</Text>
            </View>
            <form>
            <View style={formStyles.fieldset}>
              <Text style={formStyles.h4}>{this.state.text.mobileNumber}</Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({ mobileNumber: text })}
                  value={this.state.mobileNumber}
                  keyboardType='text'
                  editable={false}
                  autoComplete
                  name="username"
                />
                <Text style={formStyles.message}>{this.state.messages.mobileNumber}</Text>
            </View>
            <View style={formStyles.fieldset}>
              <Text style={formStyles.h4}>{this.state.text.password}<PasswordPolicyTooltip/></Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({password: text})}
                  value={this.state.password}
                  keyboardType='password'
                  autoComplete
                  name="password"
                />
                <Text style={formStyles.message}>{this.state.messages.password}</Text>
            </View>
            <View>
              {
                this.state.registering ?
                  <View style={formStyles.submitButtonDisabled}>
                    <Text style={formStyles.submitButtonText}>
                      {this.state.text.pleaseWait}
                    </Text>
                  </View> :
                  <TouchableOpacity
                    style={formStyles.submitButton}
                    onPress={() => this._clickSetPasswordButton()}
                  >
                    <Text style={formStyles.submitButtonText}>
                      {this.state.text.setPassword}
                    </Text>
                  </TouchableOpacity>
              }
            </View>
            </form>
          </ScrollView>
         </Grid>
           <Hidden xsDown>
            <div style={{marginRight: '5%'}} />
           </Hidden>
      </Grid>
      <Footer/>
   </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'stretch',
  },
  fieldsetldset: {
    margin: 'auto',
    minWidth: 300,
    maxWidth: 600,
    minHeight: 580,
    paddingLeft: 20,
   paddingRight: 20,
  },
};
